import {ToastProps} from "../../BaseProps";
import {AssignItemType} from "types/ActivityFeedTypes";
import BaseItem from "./BaseItem";
import SystemIndex from "assets/icons/system/system.index";
import IconBaseProps from "./IconBaseProps";
import {enActivityFeedLabel} from "constants/index";
import {getActivityName} from "components/ActivityFeed/utils";
import {useDocument} from "hooks/index";
import {doc} from "firebase/firestore";
import {userActivityFeedPath} from "../../utility";
import {SkeletonItem} from "components/index";

interface AssignedItemProps extends ToastProps {
  itemId: string;
  uid: string;
  index: number;
  updatePinnedValue: (index: number, pinned: boolean) => void;
}

function AssignedItem(props: AssignedItemProps) {
  const {toastProps, itemId, uid, updatePinnedValue, index} = props;

  const [activityFeed] = useDocument<AssignItemType>(doc(userActivityFeedPath(uid), itemId));

  if (!activityFeed) {
    return <SkeletonItem height={"5rem"} sx={{marginTop: "5px", width: "80%"}}/>
  }

  const {details} = activityFeed;
  const {by, name} = details;

  return <BaseItem
    index={index}
    uid={uid}
    item={activityFeed}
    icon={<SystemIndex.SystemIcons.ArrowRight {...IconBaseProps}/>}
    text={enActivityFeedLabel.assigned(name, by.name ?? "", getActivityName(activityFeed))}
    toastProps={toastProps}
    updatePinnedValue={updatePinnedValue}
  />
}

export default AssignedItem
